<script setup>

import DepositPaymentBase from "components/order/deposit_payment/DepositPaymentBase.vue";
import { useRouter } from "vue-router";
import Orders from "src/composables/Orders";
import { onMounted, ref } from "vue";
import CpNotice from "components/order/CpNotice.vue";

const router = useRouter();
const loading = ref(false);
const { order, order_status, make_payment, get_deposit_payment_link } = Orders();
const payment_signature = ref(null);
const error_message = ref(null);
const callback = async (response) => {
  const data = await make_payment({
    payment_url: JSON.stringify(payment_signature.value),
    payment_amount: order.value.customer_check_response.value.deposit_amount,
    ...response
  });
  router.push({ path: '/order/processing' })
}

const prepopulateFields = {};

onMounted(async () => {
  loading.value = true;

  payment_signature.value = await get_deposit_payment_link();
  const params = {
    signature: payment_signature.value.signature,
    token: payment_signature.value.token,
    tenantId: payment_signature.value.tenant_id,
    key: payment_signature.value.key,
    id: payment_signature.value.hosted_page_id,
    url: payment_signature.value.hosted_page_url,

    authorizationAmount: order.value.customer_check_response.value.deposit_amount,

    style: "inline",
    submitEnabled: "true",
    locale: "en_US",
  }

  Z.render(
      params,
      prepopulateFields,
      callback
  )
  loading.value = false;
})
</script>

<template>
  <deposit-payment-base>
    <q-card-section class="q-mt-lg">

      <cp-notice v-if="order_status === 'payment_declined'" type="negative" :header="`Your payment was declined by ${order.brand}.`" :lines="[`Please verify and resubmit your payment information.`]"></cp-notice>

      <div class="text-125 q-mb-xl">
        Pay ${{ order.customer_check_response.value.deposit_amount }} refundable deposit payment to complete your
        order now.
      </div>

      <div class="row justify-start">
        <div class="col-12 col-md-6 bg-grey-2 q-pa-lg more-rounded-borders relative-position">
          <div class="flex q-gutter-x-md q-mb-lg justify-center">
            <q-icon size="lg" name="svguse:custom-icons.svg#visa"></q-icon>
            <q-icon size="lg" name="svguse:custom-icons.svg#mastercard"></q-icon>
            <q-icon size="lg" name="svguse:custom-icons.svg#discover"></q-icon>
            <q-icon size="lg" name="svguse:custom-icons.svg#amex"></q-icon>
          </div>

          <q-inner-loading :showing="loading">
            <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
          </q-inner-loading>
          <div id="zuora_payment" class="q-pa-lg full-width"></div>

          <span class="text-negative" v-if="error_message">{{ error_message }}</span>
        </div>
      </div>
    </q-card-section>
  </deposit-payment-base>
</template>

<style scoped>
</style>
